<nav id="navbar" class="navbar navbar-expand-lg navbar-light fixed-top">
  <a class="navbar-brand" routerLink="/">Shore Rentals</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarNavDropdown">
    <ul class="navbar-nav">
      <li class="nav-item active">
        <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#feature-title">Features</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#pricing-title">How to Book</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="#contact-title">Contact</a>
      </li>
    </ul>
  </div>
</nav>

